module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/comment-84709e21896156e36bc123fde38db860.svg&quot;;"